import { render, staticRenderFns } from "./WhiteCards.vue?vue&type=template&id=ba93be20&scoped=true&"
import script from "./WhiteCards.vue?vue&type=script&lang=js&"
export * from "./WhiteCards.vue?vue&type=script&lang=js&"
import style0 from "./WhiteCards.vue?vue&type=style&index=0&id=ba93be20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba93be20",
  null
  
)

export default component.exports